
import {getFinanceApi} from '@/api/finance'
import { getSetting } from '@/api/setting.js'
import { quickbooksFetch } from '@/api/common'
export const FinanceMixin = {
  created () {
    // this.fetchCLientFinance()
    this.fetchSetting()
  },
  data () {
    return {
      quickBook: null,
      payment:[],
      schoolAddress:null,
      platformCustomerInfo:null,
      paymentOpt:[
        {text:'Stripe', value:1},
        {text:'Debit Card', value:2},
        {text:'Credit Card', value:3}
      ],
      status:[],
      dateRange:{},
      selected:[],
      course:[],
      courseOpt:[
        {text:'Instrumental', value:1},
        {text:'Instrumental Pro', value:2},
        {text:'Instrumental Elite', value:3}
      ],
      statusOpt:[
        {text:'Overdue', value:1},
        {text:'Pending', value:2},
        {text:'Paid', value:3}
      ],
      clientsListInvoices:[]
    }
  },
  methods:{
    async fetchCLientFinance (page = 1, limit = 5, payload) {
      try {    
        this.$vs.loading({text:'Fetching Students Invoice. Please wait...'})
        const customer_id = localStorage.getItem('customer_id')
        const responseData = await getFinanceApi(page, limit, customer_id, payload)
        
        this.clientsListInvoices = responseData.data.data.invoices
        this.schoolAddress = responseData.data.data.address
        this.platformCustomerInfo = responseData.data.data.platform_customer
        this.meta = responseData.data.data.meta
        
      } catch (error) {
        
      } finally {
        this.$vs.loading.close()
      }
    },
    async quickbooksFetch (page) {
      try {
        const responseData = await quickbooksFetch(page, localStorage.getItem('customer_id'))
        this.clientsListInvoices = responseData.data.data.invoices
        this.schoolAddress = responseData.data.data.address
        this.platformCustomerInfo = responseData.data.data.platform_customer
        this.meta = responseData.data.data.meta
      } catch (e) {
        console.log(e) 
      } 
    },
    async fetchSetting () {
      const { data } = await getSetting(localStorage.getItem('customer_id'))
      if (data.data[0] !== null) {
        this.quickBook = data.data[0].quickbook_enable
      }
    }
  }
}